import React from 'react'
import Counter from "../Components/Counter"

function Home() {
  return (
    <div className="mil-wrapper">
      <div id="content">
            <section class="mil-banner">
                <img src="assets/images/background/background-1.png" class="mil-bg-img mil-scale" data-value-1=".4" data-value-2="1.4" alt="Top banner background" />
                <div class="container">
                    <div class="mil-background-grid mil-top-space"></div>
                    <div class="mil-banner-content">
                        <div class="row align-items-end">
                            <div class="col-xl-7">
                              <img
                                src="assets/images/logo/logo-light.png"
                                alt="Logo"
                                style={{ width: "130px"}}
                                className="mb-4"
                              />
                                <div className="mil-mb-90 sc-h1-txt">
                                    <h1 class="mil-upper mil-light mil-mb-60">FIRMA<br /><span class="mil-accent">OGÓLNOBUDOWLANA</span><br />HOŁ - BUD</h1>
                                </div>
                            </div>
                            <div class="col-xl-5">
                                <div class="row mil-mb-60">
                                    <div class="col-6">

                                        <div className="mil-counter-frame mil-light mil-mb-30">
                                          <h4 className="mil-accent mil-thin mil-mb-10">
                                            <Counter target={1000} />+
                                          </h4>
                                          <p className="mil-light">
                                            Wykonanych <br />zleceń
                                          </p>
                                        </div>

                                    </div>
                                    <div class="col-6">

                                        <div class="mil-counter-frame mil-light mil-mb-30">
                                           <h4 className="mil-accent mil-thin mil-mb-10">
                                            <Counter target={30} />+
                                          </h4>
                                            <p class="mil-light">Doświadczonych <br />pracowników</p>
                                        </div>

                                    </div>
                                    <div class="col-6">

                                        <div class="mil-counter-frame mil-light mil-mb-30">
                                           <h4 className="mil-accent mil-thin mil-mb-10">
                                            <Counter target={10} />+
                                          </h4>
                                            <p class="mil-light">Lat <br />doświadczenia</p>
                                        </div>

                                    </div>
                                    <div class="col-6">

                                        <div class="mil-counter-frame mil-light mil-mb-30">
                                           <h4 className="mil-accent mil-thin mil-mb-10">
                                            <Counter target={50000} />+
                                          </h4>
                                            <p class="mil-light">Godzin <br />pracy</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div class="container mil-p-0-30">
                    <div class="mil-background-grid mil-softened"></div>
                    <div class="row justify-content-between align-items-center flex-sm-row-reverse">
                        <div class="col-lg-5">

                            <div class="mil-mb-90">
                                <span class="mil-suptitle mil-upper mil-up mil-mb-30">O NAS</span>
                                <h2 class="mil-upper mil-up mil-mb-30">BUDUJEMY Z PASJĄ</h2>
                                <p class="mil-up mil-mb-40">HOŁ-BUD to firma zrodzona z pasji do budownictwa, przekazywanej z pokolenia na pokolenie. Nasze korzenie sięgają 1992 roku. Dziś, z ponad dekadą własnych doświadczeń na rynku i wiedzą szlifowaną w kraju i za granicą, oferujemy kompleksowe usługi budowlane.</p>
                                <p class="mil-up mil-mb-40">Specjalizujemy się w budowie "pod klucz", realizując wizje naszych klientów od projektu, przez budowę, aż po finalne wykończenie. Jesteśmy dumni z naszej historii i zaufania, jakim obdarzyli nas klienci.</p>
                                <a href="/realizacje" class="mil-link mil-upper mil-up has-popup-video">NASZE REALIZACJE <span class="mil-arrow"><img src="assets/images/icons/2.svg" alt="arrow" /></span></a>
                            </div>

                        </div>
                        <div class="col-lg-6">

                            <div class="mil-illustration mil-up mil-mb-90">
                                <div class="mil-image-frame">
                                    <img src="assets/images/photo/2.png" alt="Zdjęcie zrealizowanej budowy domu wielorodzinnego." class="mil-scale" data-value-1="1" data-value-2="1.3" />
                                </div>
                                <div class="mil-about-counter">
                                    <h1 class="mil-counter mil-right mil-mb-10">
                                      +<Counter target={10} /> lat
                                    </h1>
                                    <h5 class="mil-upper mil-right"><span class="mil-marker">doświadczenia</span><br />w branży <br />budowlanej</h5>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <section class="mil-soft-bg mil-relative">
                <img src="assets/images/background/background-3.png" class="mil-bg-img" alt="Tło naszej oferty budowy mieszkalnego, wieloridznnego, usługowo-przemysłowego." />
                <div class="container mil-p-120-90">
                    <div class="mil-background-grid mil-softened"></div>

                    <div class="row">
                        <div class="col-12">

                            <div class="mil-center mil-mb-90">
                                <span class="mil-suptitle mil-upper mil-up mil-mb-30">NASZA OFERTA</span>
                                <h2 class="mil-upper mil-up">CO ROBIMY</h2>
                            </div>

                        </div>
                        <div class="col-lg-4">

                            <a href="/budownictwo-mieszkalne" class="mil-service-card mil-up mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">BUDOWNICTWO MIESZKALNE</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Kompleksowa budowa domów od fundamentów aż po dach, włączając w to stany surowe, dekarstwo, prace żelbetonowe i murarskie.</p>
                                    <div class="mil-go-buton mil-icon mil-icon-lg mil-icon-accent-bg">
                                        <img src="assets/images/icons/1.svg" alt="icon" />
                                    </div>
                                </div>
                            </a>

                        </div>
                        <div class="col-lg-4">

                            <a href="/budownictwo-wielorodzinne" class="mil-service-card mil-up mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">BUDOWNICTWO WIELORODZINNE</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Realizacja inwestycji deweloperskich. Posiadamy doświadczenie we współpracy z wiodącymi deweloperami w regionie.</p>
                                    <div class="mil-go-buton mil-icon mil-icon-lg mil-icon-accent-bg">
                                       <img src="assets/images/icons/1.svg" alt="icon" />
                                    </div>
                                </div>
                            </a>

                        </div>
                        <div class="col-lg-4">

                            <a href="/budownictwo-uslugowo-przemyslowe" class="mil-service-card mil-up mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">BUDOWNICTWO USŁUGOWO-PRZEMYSŁOWE</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Wznoszenie hal, magazynów i obiektów przemysłowych. Oferujemy pełen zakres prac, od ziemnych po wykończeniowe.</p>
                                    <div class="mil-go-buton mil-icon mil-icon-lg mil-icon-accent-bg">
                                       <img src="assets/images/icons/1.svg" alt="icon" />
                                    </div>
                                </div>
                            </a>

                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div class="container mil-p-120-60">
                    <div class="mil-background-grid mil-softened"></div>

                    <div class="row">
                        <div class="col-12">

                            <div class="mil-center mil-mb-90">
                                <span class="mil-suptitle mil-upper mil-up mil-mb-30">NASZA OFERTA</span>
                                <h2 class="mil-upper mil-up mil-mb-30">ZAJMIEMY SIĘ WSZYSTKIM<br />ZA CIEBIE!</h2>
                              
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-advantage mil-icon-box mil-center mil-up mil-mb-60">
                                <h4 class="mil-upper mil-mb-30">SŁUCHAMY</h4>
                                <div class="mil-icon mil-icon-border mil-mb-30">
                                    <img src="assets/images/icons/6.svg" alt="icon" />
                                </div>
                                <p>Zaczynamy od rozmowy. Analizujemy Twoje potrzeby, pomysły i oczekiwania, aby w pełni zrozumieć wizję projektu.</p>
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-advantage mil-icon-box mil-center mil-up mil-mb-60">
                                <h4 class="mil-upper mil-mb-30">PLANUJEMY</h4>
                                <div class="mil-icon mil-icon-border mil-mb-30">
                                    <img src="assets/images/icons/6.svg" alt="icon" />
                                </div>
                                <p>Tworzymy szczegółowy plan działania, harmonogram prac i profesjonalną wycenę. Rezerwujemy termin i załatwiamy formalności.</p>
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-advantage mil-icon-box mil-center mil-up mil-mb-60">
                                <h4 class="mil-upper mil-mb-30">BUDUJEMY</h4>
                                <div class="mil-icon mil-icon-border mil-mb-30">
                                    <img src="assets/images/icons/6.svg" alt="icon" />
                                </div>
                                <p>Przechodzimy do realizacji. Nasz doświadczony zespół sprawnie i solidnie wykonuje wszystkie prace budowlane zgodnie z planem.</p>
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-advantage mil-icon-box mil-center mil-up mil-mb-60">
                                <h4 class="mil-upper mil-mb-30">WYKAŃCZAMY</h4>
                                <div class="mil-icon mil-icon-border mil-mb-30">
                                    <img src="assets/images/icons/6.svg" alt="icon" />
                                </div>
                                <p>Dopracowujemy detale, wykonujemy prace wykończeniowe i przygotowujemy budynek do oficjalnego odbioru i przekazania kluczy.</p>
                            </div>

                        </div>

                    </div>
                </div>
            </section>

            <section>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/home/1.png" alt="Realizacja domu wielorodzinnego." />
                            </div>

                            <div class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/home/2.png" alt="Budowa domu jednorodzinnego." />
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-long-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/home/3.png" alt="Stan surowy zamknięty domu wielorodzinnego." />
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/home/4.png" alt="Budowa osiedla mieszkalnego." />
                            </div>

                            <div href="project.html" class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/home/5.png" alt="Budowa domu jednorodzinnego od podstaw." />
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-long-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/home/6.png" alt="Stan surowy domu wielorodzinnego z przestrzenią usługową." />
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div class="container mil-p-90-60">
                    <div class="mil-background-grid mil-softened"></div>

                    <div class="row">
                        <div class="col-12">
                            <div class="mil-center mil-mb-90">
                                <span class="mil-suptitle mil-upper mil-up mil-mb-30">JAK PRACUJEMY</span>
                                <h2 class="mil-upper mil-up">CO NAS WYRÓŻNIA</h2>
                            </div>

                        </div>
                        <div class="col-lg-4">

                            <div class="mil-hww mil-icon-box mil-up mil-mb-60">
                                <div class="mil-icon mil-icon-border mil-mb-30">
                                </div>
                                <h4 class="mil-upper mil-mb-20">PROFESJONALIZM</h4>
                                <div class="mil-divider-sm mil-mb-20"></div>
                                <p>Do każdego zlecenia podchodzimy z pełnym zaangażowaniem, stosując nowoczesne technologie i materiały najwyższej jakości.</p>
                            </div>

                        </div>
                        <div class="col-lg-4">

                            <div class="mil-hww mil-icon-box mil-up mil-mb-60">
                                <div class="mil-icon mil-icon-border mil-mb-30">
                                </div>
                                <h4 class="mil-upper mil-mb-20">DOŚWIADCZENIE</h4>
                                <div class="mil-divider-sm mil-mb-20"></div>
                                <p>Wieloletnia praktyka w branży i wiedza przekazywana z pokolenia na pokolenie to gwarancja solidności i niezawodności.</p>
                            </div>

                        </div>
                        <div class="col-lg-4">

                            <div class="mil-hww mil-icon-box mil-up mil-mb-60">
                                <div class="mil-icon mil-icon-border mil-mb-30">
                                </div>
                                <h4 class="mil-upper mil-mb-20">SUMIENNOŚĆ</h4>
                                <div class="mil-divider-sm mil-mb-20"></div>
                                <p>Dbamy o detale, porządek na budowie i terminowość. Budujemy relacje oparte na zaufaniu i transparentności.</p>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

          </div>
    </div>
  )
}

export default Home